/* eslint-disable consistent-return */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-destructuring */
import { ArrowBack, SearchRounded } from '@mui/icons-material';
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import TextField from '@mui/material/TextField/TextField';
import dayjs from 'dayjs';
import * as xlsx from 'xlsx';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { InfoCard } from '../../components/InfoCard';
import { LogToView } from '../../services/requests/app-logs/types';
import { getLogsByCompanyId } from '../../services/requests/app-logs/utils';
import useAuthStore from '../../store/auth';
import useCompanyStore from '../../store/companies';
import { BallStatus } from '../Boards/BoardDetails/styles';
import { Container, Filters, Header, Title } from './styles';
import { InputRange } from '../../components/InputRange';
import { getUsersByCompanyIdRequest } from '../../services';
import { formatLogValue, getFieldNames } from '../../utils/logHelper';

const local = [
  'Acessos',
  'Reuniões',
  'Board',
  'Arquivos',
  // 'Anotação',
  'Assinaturas',
  'Usuario',
  'Pautas',
  'Pastas',
];
const actions = ['Acessou', 'Criou', 'Alterou', 'Visualizou', 'Deletou'];
const headerExcel = [
  'ID Log',
  'Nome',
  'ID do Usuário',
  'ID da Empresa',
  'Local da Ação',
  'Ação',
  'Descrição da Ação',
  'IP do Usuário',
  'Criado em',
];

export const Logs = () => {
  const setMenuSelected = useAuthStore(state => state.setMenuSelected);
  const selectCompany = useCompanyStore(state => state.selectedCompany);
  const user = useAuthStore(state => state.user);
  const navigate = useNavigate();

  const [loadingTable, setLoadingTable] = useState(false);
  const [page, setPage] = useState(0);
  const [listagemLogs, setListagemLogs] = useState<LogToView[]>([]);
  const [dataValue, setDataValue] = useState('');
  const [rangeDate, setRangeDate] = useState<Date[] | null>(null);
  const [search, setSearch] = useState<string | null>();
  const [searchinput, setSearchInput] = useState('');
  const [localValue, setLocalValue] = useState<string | null>();
  const [localInput, setLocalInput] = useState('');
  const [actionValue, setActionValue] = useState<string | null>();
  const [actionInput, setActionInput] = useState('');
  const [localIdValue, setLocalIdValue] = useState<string | null>();
  const [localIdInput, setLocalIdInput] = useState('');
  const [userValue, setUserValue] = useState<string | null>();
  const [userInput, setUserInput] = useState('');
  const [sizeLogs, setSizeLogs] = useState(10);
  const [companyUsersNames, setCompanyUsersNames] = useState(['']);
  const [companyUsers, setCompanyUsers] = useState([]);
  const [countLogs, setCountLogs] = useState<number>();

  const listagemId = listagemLogs?.map(e => e.user_id);
  const uniqueIds = listagemId.filter(
    (este, i) => listagemId.indexOf(este) === i,
  );

  const getUsersByCompanyId = useCallback(async () => {
    try {
      const response = await getUsersByCompanyIdRequest(
        selectCompany?.id as string,
        '',
        '',
        '1000',
        '',
      );

      if (response?.status === 200) {
        const usersName = response?.data?.data?.map((u: any) => u.name);
        setCompanyUsersNames(usersName);
        setCompanyUsers(response?.data?.data);
      }
    } catch (err) {
      console.log();
    }
  }, [selectCompany?.id]);

  const getLogs = useCallback(async () => {
    try {
      const initialDate =
        rangeDate && rangeDate.length > 0
          ? dayjs(rangeDate[0]).format('YYYY-MM-DD 00:00')
          : [];
      const finalDate =
        rangeDate && rangeDate.length > 0
          ? dayjs(rangeDate[1]).format('YYYY-MM-DD 23:59')
          : [];

      const joinedDate = `${initialDate} / ${finalDate}`;
      setLoadingTable(true);
      const response = await getLogsByCompanyId(
        selectCompany?.id as string,
        user?.id as string,
        search as string,
        userValue as string,
        localValue as string,
        actionValue as string,
        joinedDate as string,
        page.toString(),
        sizeLogs.toString(),
      );

      if (response?.status === 200) {
        const logsFormatted = response.data.logs?.map((log: any) => {
          const keysArray = log?.isEncrypt ? [] : Object.keys(log?.old_value);
          const antesArray = log?.old_value
            ? Object.values(log?.old_value)
            : [];
          const depoisArray = log?.new_value
            ? Object.values(log.new_value)
            : [];

          const changesQtd = keysArray?.length === 0 ? 1 : keysArray?.length;

          const firstElCampo = log?.isEncrypt
            ? log?.id_entity?.slice(0, 8)
            : keysArray?.length > 0
            ? keysArray[0]
            : '';
          const firstElAntes = log?.isEncrypt
            ? log?.id_entity?.slice(0, 8)
            : antesArray?.length > 0
            ? antesArray[0]
            : '';
          const firstElDepois = log?.isEncrypt
            ? log?.id_entity?.slice(0, 8)
            : depoisArray?.length > 0
            ? depoisArray[0]
            : '';

          const formattedLog = {
            ...log,
            old_value: formatLogValue(firstElAntes),
            new_value: formatLogValue(firstElDepois),
            field: getFieldNames(firstElCampo),
            changesQtd,
            keysArray,
            antesArray,
            depoisArray,
          };

          return formattedLog;
        });

        setCountLogs(response?.data?.logsCount);
        setListagemLogs(logsFormatted);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingTable(false);
    }
  }, [
    selectCompany?.id,
    user?.id,
    search,
    userValue,
    localValue,
    actionValue,
    rangeDate,
    page,
    sizeLogs,
  ]);

  useEffect(() => {
    // setLoading(true);
    if (selectCompany) {
      const delayDebounceFn = setTimeout(() => {
        getLogs();
      }, 1000);
      return () => clearTimeout(delayDebounceFn);
    }
  }, [search]);

  useEffect(() => {
    if (selectCompany) {
      getLogs();
      getUsersByCompanyId();
    }
  }, [userValue, localValue, actionValue, rangeDate, page, sizeLogs]);

  const handleGoBack = useCallback(() => {
    navigate('/home/reunioes');
    setMenuSelected('portal');
  }, [navigate, setMenuSelected]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    setSizeLogs(parseInt(event.target.value, 10));

    setPage(0);
  };

  const handleExportLogsToExcel = () => {
    const wb = xlsx.utils.book_new();
    const ws = xlsx.utils.sheet_add_json(wb, listagemLogs, {
      origin: 'A2',
      skipHeader: true,
    });
    xlsx.utils.sheet_add_aoa(wb, [headerExcel]);
    xlsx.utils.book_append_sheet(wb, ws, 'LogsExcel');

    xlsx.writeFile(wb, 'Ten Gov - LogsExcel.xlsx');
  };

  const handleChangeData = (event: any) => {
    console.log({ event });
    // setDataValue(event?.current?.target);
    setDataValue(event?.target?.value);

    setPage(0);
  };

  const handleChangeLocal = (event: any, newValue: string | null) => {
    setLocalValue(newValue);
    setPage(0);
  };

  const handleChangeAction = (event: any, newValue: string | null) => {
    setActionValue(newValue);
    setPage(0);
  };

  const handleChangeUser = (event: any, newValue: string | null) => {
    setUserValue(newValue);
    setPage(0);
  };

  const defaultLabelDisplayedRows = ({ from, to, count }: any) => {
    return `${from}–${to} de ${count !== -1 ? count : `mais de ${to}`}`;
  };

  return (
    <Container>
      <Header>
        <Button
          onClick={handleGoBack}
          sx={{
            display: 'flex',
            gap: '10px',
            color: '#212121',
            borderColor: '#212121',
            width: '213px',
            height: '48px',
            fontWeight: '500',
            fontSize: '15px',
            whiteSpace: 'nowrap',
          }}
          variant="outlined"
        >
          <ArrowBack /> Voltar ao portal
        </Button>
        <Title>Logs</Title>
      </Header>
      <Filters>
        <TextField
          value={search}
          onChange={event => setSearch(event.target.value)}
          placeholder="Pesquisar"
          InputProps={{ endAdornment: <SearchRounded /> }}
          sx={{
            background: '#FFFFFF',
            borderRadius: '4px',
            padding: '0',
          }}
          fullWidth
        />
        <Autocomplete
          disablePortal
          options={companyUsersNames as string[]}
          fullWidth
          value={userValue}
          onChange={handleChangeUser}
          inputValue={userInput}
          onInputChange={(event, newInputValue) => {
            setUserInput(newInputValue);
          }}
          renderInput={params => (
            <TextField
              {...params}
              placeholder="Usuário"
              sx={{
                background: '#FFFFFF',
                borderRadius: '4px',
                padding: '0',
              }}
            />
          )}
        />
        <InputRange
          rangeDate={rangeDate}
          setRangeDate={setRangeDate}
          setPage={setPage}
        />
        {/* <div className="flatpickr">
          <input
            type="text"
            placeholder="Data"
            className="flatpickr-inputt"
            value={dataValue}
            onChange={handleChangeData}
          />
        </div> */}
        {/* <TextField
          fullWidth
          type="date"
          placeholder="Data"
          // className="flatpickr-inputt"
          value={dataValue}
          onChange={handleChangeData}
          sx={{
            background: '#FFFFFF',
            borderRadius: '4px',
            padding: '0',
          }}
        /> */}
        {/* <Autocomplete
          disablePortal
          options={uniqueIds}
          fullWidth
          value={localIdValue}
          onChange={(event: any, newValue: string | null) => {
            setLocalIdValue(newValue);
          }}
          inputValue={localIdInput}
          onInputChange={(event, newInputValue) => {
            setLocalIdInput(newInputValue);
          }}
          renderInput={params => (
            <TextField
              {...params}
              placeholder="ID (local)"
              sx={{
                background: '#FFFFFF',
                borderRadius: '4px',
                padding: '0',
              }}
            />
          )}
        /> */}
        <Autocomplete
          disablePortal
          options={actions}
          fullWidth
          value={actionValue}
          onChange={handleChangeAction}
          inputValue={actionInput}
          onInputChange={(event, newInputValue) => {
            setActionInput(newInputValue);
          }}
          renderInput={params => (
            <TextField
              {...params}
              placeholder="Ação"
              sx={{
                background: '#FFFFFF',
                borderRadius: '4px',
                padding: '0',
              }}
            />
          )}
        />
        <Autocomplete
          disablePortal
          options={local}
          fullWidth
          value={localValue}
          onChange={handleChangeLocal}
          inputValue={localInput}
          onInputChange={(event, newInputValue) => {
            setLocalInput(newInputValue);
          }}
          renderInput={params => (
            <TextField
              {...params}
              placeholder="Local"
              sx={{
                background: '#FFFFFF',
                borderRadius: '4px',
                padding: '0',
              }}
            />
          )}
        />

        {/* <Button
          variant="outlined"
          style={{
            display: 'flex',
            gap: '10px',
            minWidth: '198px',
            height: '54px',
            fontWeight: '500',
            fontSize: '15px',
            whiteSpace: 'nowrap',
          }}
          onClick={handleExportLogsToExcel}
        >
          <DownloadRounded /> Exportar excel
        </Button> */}
      </Filters>

      {loadingTable ? (
        <Box width="100%" display="flex" justifyContent="center" mt="200px">
          <CircularProgress />
        </Box>
      ) : (
        <Paper sx={{ width: '100%' }}>
          {listagemLogs?.length > 0 ? (
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell
                    sx={{
                      color: 'rgba(0, 0, 0, 0.54)',
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '16px',
                    }}
                  >
                    NOME
                  </TableCell>
                  <TableCell
                    sx={{
                      color: 'rgba(0, 0, 0, 0.54)',
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '16px',
                    }}
                  >
                    DATA
                  </TableCell>
                  <TableCell
                    sx={{
                      color: 'rgba(0, 0, 0, 0.54)',
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '16px',
                    }}
                  >
                    AÇÃO
                  </TableCell>
                  <TableCell
                    sx={{
                      color: 'rgba(0, 0, 0, 0.54)',
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '16px',
                    }}
                  >
                    DESCRIÇÃO
                  </TableCell>
                  <TableCell
                    sx={{
                      color: 'rgba(0, 0, 0, 0.54)',
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '16px',
                    }}
                  >
                    CAMPO
                  </TableCell>
                  <TableCell
                    sx={{
                      color: 'rgba(0, 0, 0, 0.54)',
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '16px',
                    }}
                  >
                    ANTES
                  </TableCell>
                  <TableCell
                    sx={{
                      color: 'rgba(0, 0, 0, 0.54)',
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '16px',
                    }}
                  >
                    DEPOIS
                  </TableCell>
                  <TableCell
                    sx={{
                      color: 'rgba(0, 0, 0, 0.54)',
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '16px',
                    }}
                  >
                    LOCAL
                  </TableCell>
                  <TableCell
                    sx={{
                      color: 'rgba(0, 0, 0, 0.54)',
                      fontWeight: '400',
                      fontSize: '14px',
                      lineHeight: '16px',
                    }}
                  >
                    IP
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {listagemLogs?.map((log, i) => (
                  <>
                    <TableRow
                      sx={{
                        backgroundColor: i % 2 === 0 ? '#f8f9fa' : '#fff',
                      }}
                    >
                      <TableCell
                        sx={{
                          color: 'rgb(0, 0, 0)',
                          fontWeight: '400',
                          fontSize: '14px',
                          lineHeight: '16px',
                          maxWidth: '10vw',
                        }}
                        rowSpan={log?.changesQtd}
                      >
                        <Tooltip title={log?.user_id}>
                          <Typography
                            sx={{
                              lineHeight: 'unset',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {log?.name}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'rgb(0, 0, 0)',
                          fontWeight: '400',
                          fontSize: '14px',
                          lineHeight: '16px',
                        }}
                        rowSpan={log?.changesQtd}
                      >
                        {dayjs(log?.created_at).format('DD/MM/YYYY HH:mm')}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'rgb(0, 0, 0)',
                          fontWeight: '400',
                          fontSize: '14px',
                          lineHeight: '16px',
                        }}
                        rowSpan={log?.changesQtd}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            gap: '10px',
                          }}
                        >
                          {log.action === 'Acessou' && (
                            <BallStatus
                              style={{
                                backgroundColor: 'rgb(34 6 217)',
                              }}
                            />
                          )}
                          {log.action === 'Criou' && (
                            <BallStatus
                              style={{
                                backgroundColor: '#4CAF50',
                              }}
                            />
                          )}
                          {log.action === 'Alterou' && (
                            <BallStatus
                              style={{
                                backgroundColor: '#FFB547',
                              }}
                            />
                          )}
                          {log.action === 'Visualizou' && (
                            <BallStatus
                              style={{
                                backgroundColor: '#47a6ff',
                              }}
                            />
                          )}
                          {log.action === 'Deletou' && (
                            <BallStatus
                              style={{
                                backgroundColor: '#E31B0C',
                              }}
                            />
                          )}
                          {log?.action}
                        </Box>
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'rgb(0, 0, 0)',
                          fontWeight: '400',
                          fontSize: '14px',
                          lineHeight: '16px',
                          maxWidth: '20vw',
                        }}
                        rowSpan={log?.changesQtd}
                      >
                        <Tooltip title={log?.description}>
                          <Typography
                            sx={{
                              lineHeight: 'unset',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {log?.description}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'rgb(0, 0, 0)',
                          fontWeight: '400',
                          fontSize: '14px',
                          lineHeight: '16px',
                          maxWidth: '5vw',
                          borderLeft: '1px solid lightGrey',
                        }}
                      >
                        <Tooltip title={log?.field}>
                          <Typography
                            sx={{
                              lineHeight: 'unset',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {log?.field}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'rgb(0, 0, 0)',
                          fontWeight: '400',
                          fontSize: '14px',
                          lineHeight: '16px',
                          maxWidth: '10vw',
                        }}
                      >
                        <Tooltip title={log?.old_value}>
                          <Typography
                            sx={{
                              lineHeight: 'unset',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {log?.old_value}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'rgb(0, 0, 0)',
                          fontWeight: '400',
                          fontSize: '14px',
                          lineHeight: '16px',
                          maxWidth: '10vw',
                          borderRight: '1px solid lightGrey',
                        }}
                      >
                        <Tooltip title={log?.new_value}>
                          <Typography
                            sx={{
                              lineHeight: 'unset',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {log?.new_value}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'rgb(0, 0, 0)',
                          fontWeight: '400',
                          fontSize: '14px',
                          lineHeight: '16px',
                        }}
                        rowSpan={log?.changesQtd}
                      >
                        {log?.local}
                      </TableCell>
                      <TableCell
                        sx={{
                          color: 'rgb(0, 0, 0)',
                          fontWeight: '400',
                          fontSize: '14px',
                          lineHeight: '16px',
                          maxWidth: '5vw',
                        }}
                        rowSpan={log?.changesQtd}
                      >
                        <Tooltip title={log?.ip}>
                          <Typography
                            sx={{
                              lineHeight: 'unset',
                              textOverflow: 'ellipsis',
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                            }}
                          >
                            {log?.ip}
                          </Typography>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                    {log?.keysArray &&
                      log?.keysArray?.length > 1 &&
                      log?.keysArray?.map((key, index) => {
                        const formattedOldValue = formatLogValue(
                          log?.antesArray[index],
                        );
                        const formattedNewValue = formatLogValue(
                          log?.depoisArray[index],
                        );

                        if (index !== 0) {
                          return (
                            <TableRow
                              key={`${log?.id}-${key}`}
                              sx={{
                                backgroundColor:
                                  i % 2 === 0 ? '#f8f9fa' : '#fff',
                              }}
                            >
                              <TableCell
                                sx={{
                                  color: 'rgb(0, 0, 0)',
                                  fontWeight: '400',
                                  fontSize: '14px',
                                  lineHeight: '16px',
                                  maxWidth: '10vw',
                                  borderLeft: '1px solid lightGrey',
                                }}
                              >
                                <Tooltip title={key}>
                                  <Typography
                                    sx={{
                                      lineHeight: 'unset',
                                      textOverflow: 'ellipsis',
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {getFieldNames(key)}
                                  </Typography>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: 'rgb(0, 0, 0)',
                                  fontWeight: '400',
                                  fontSize: '14px',
                                  lineHeight: '16px',
                                  maxWidth: '10vw',
                                }}
                              >
                                <Tooltip title={formattedOldValue}>
                                  <Typography
                                    sx={{
                                      lineHeight: 'unset',
                                      textOverflow: 'ellipsis',
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {formattedOldValue}
                                  </Typography>
                                </Tooltip>
                              </TableCell>
                              <TableCell
                                sx={{
                                  color: 'rgb(0, 0, 0)',
                                  fontWeight: '400',
                                  fontSize: '14px',
                                  lineHeight: '16px',
                                  maxWidth: '10vw',
                                  borderRight: '1px solid lightGrey',
                                }}
                              >
                                <Tooltip title={formattedNewValue}>
                                  <Typography
                                    sx={{
                                      lineHeight: 'unset',
                                      textOverflow: 'ellipsis',
                                      overflow: 'hidden',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {formattedNewValue}
                                  </Typography>
                                </Tooltip>
                              </TableCell>
                            </TableRow>
                          );
                        }
                      })}
                  </>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Box display="flex" justifyContent="center" width="100%" mt="50px">
              <InfoCard title="Nenhum log encontrado!" type="info" />
            </Box>
          )}

          <TablePagination
            backIconButtonProps={{ disabled: page === 0 }}
            nextIconButtonProps={{
              disabled:
                (sizeLogs === 5 && listagemLogs?.length < 5) ||
                (sizeLogs === 10 && listagemLogs?.length < 10) ||
                (sizeLogs === 25 && listagemLogs?.length < 25),
            }}
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={countLogs as number}
            rowsPerPage={sizeLogs}
            page={page}
            labelRowsPerPage="Linhas por página"
            labelDisplayedRows={defaultLabelDisplayedRows}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
      )}
    </Container>
  );
};
